import React, { PureComponent } from 'react';
import { css } from 'emotion';

import Dropdown from '../../../../../common/components/core/Dropdown';

import Colors from '../../../../../../styles/Colors';

const iconClassName = css({
  fontFamily: 'Material Icons',
  fontSize: '24px',
  color: Colors['@gray-chateau'],
  paddingRight: '5px'
});

const defaultCustomStyles = {
  control: providedStyling => ({
    ...providedStyling,
    boxSizing: 'border-box',
    height: '35px',
    border: `1px solid ${Colors['@gallery']}`,
    borderRadius: '6px',
    backgroundColor: Colors['@white']
  })
};

export class CustomDropdownIndicator extends PureComponent {
  render() {
    if (!this.props.icon) {
      return null;
    }
    return <span className={iconClassName}>{this.props.icon}</span>;
  }
}

class DiscoAdsCreatorCustomDropdown extends PureComponent {
  render() {
    const {
      customStyles,
      onMenuOpen,
      onMenuClose,
      icon,
      ...remainingProps
    } = this.props;
    const styles = { ...defaultCustomStyles, ...customStyles };
    return (
      <Dropdown
        onOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        styles={styles}
        components={{
          DropdownIndicator: () => <CustomDropdownIndicator icon={icon} />
        }}
        {...remainingProps}
      />
    );
  }
}

export default DiscoAdsCreatorCustomDropdown;
